import {OnInit, Component, Input, ChangeDetectorRef, NgModule} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {LayoutService} from '../../../../layout/src/lib/layout.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {CommonModule} from '@angular/common';
import {TranslocoModule} from '@ngneat/transloco';
import {CalculateEllipsisDirectiveModule} from 'shared/lib/calculate-ellipsis/calculate-ellipsis.directive';

@UntilDestroy()
@Component({
	selector: 'shared-text-with-ellipsis',
	templateUrl: './text-with-ellipsis.component.html',
	styleUrls: ['./text-with-ellipsis.component.scss']
})
export class TextWithEllipsisComponent implements OnInit {
	@Input() content: string;

	@Input() lines: string;

	@Input() lineHeight: number;

	@Input() hideShowMoreBtn = false;

	sanitizedContent: SafeHtml;
	overflowHidden = true;

	theme: string;
	currentTheme$ = this.layout.currentTheme$;

	constructor(private sanitizer: DomSanitizer, private cdr: ChangeDetectorRef, private layout: LayoutService) {
		this.currentTheme$.pipe(
			untilDestroyed(this)
		).subscribe(val => this.theme = `theme-${val}`);
	}

	ngOnInit() {
		this.sanitizedContent = this.sanitizer.bypassSecurityTrustHtml(this.content);
	}

	hideExpandContent() {
		this.overflowHidden = !this.overflowHidden;
		this.cdr.markForCheck();
		this.cdr.detectChanges();
	}
}

@NgModule({
	declarations: [TextWithEllipsisComponent],
	imports: [CommonModule, TranslocoModule, CalculateEllipsisDirectiveModule],
	exports: [TextWithEllipsisComponent]
})
export class TextWithEllipsisModule {}
